var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCcs2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "37px",
    height: "43px",
    viewBox: "0 0 37 43",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CCS 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App-IOS",
    stroke: "none",
    strokeWidth: 1,
    fill: "#6D6E71",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home/Search-Copy",
    transform: "translate(-299.000000, -398.000000)",
    stroke: "#020303"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(36.000000, 373.488281)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CCS-2",
    transform: "translate(264.000000, 25.511719)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.155,12.467 C34.155,21.897 26.508,29.545 17.077,29.545 C7.647,29.545 0,21.897 0,12.467 C0,7.549 2.08,3.115 5.41,0 L28.745,0 C32.075,3.115 34.155,7.549 34.155,12.467 Z",
    id: "Stroke-1",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.882,21.6889 C15.882,23.7639 14.2,25.4459 12.125,25.4459 C10.05,25.4459 8.368,23.7639 8.368,21.6889 C8.368,19.6139 10.05,17.9319 12.125,17.9319 C14.2,17.9319 15.882,19.6139 15.882,21.6889 Z",
    id: "Stroke-3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1285,21.6889 C26.1285,23.7639 24.4465,25.4459 22.3715,25.4459 C20.2965,25.4459 18.6145,23.7639 18.6145,21.6889 C18.6145,19.6139 20.2965,17.9319 22.3715,17.9319 C24.4465,17.9319 26.1285,19.6139 26.1285,21.6889 Z",
    id: "Stroke-5",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5879,12.8085 C10.5879,14.8835 8.9059,16.5655 6.8309,16.5655 C4.7559,16.5655 3.0739,14.8835 3.0739,12.8085 C3.0739,10.7335 4.7559,9.0515 6.8309,9.0515 C8.9059,9.0515 10.5879,10.7335 10.5879,12.8085 Z",
    id: "Stroke-7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4226,12.8085 C31.4226,14.8835 29.7406,16.5655 27.6656,16.5655 C25.5906,16.5655 23.9086,14.8835 23.9086,12.8085 C23.9086,10.7335 25.5906,9.0515 27.6656,9.0515 C29.7406,9.0515 31.4226,10.7335 31.4226,12.8085 Z",
    id: "Stroke-9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0052,12.8085 C21.0052,14.8835 19.3232,16.5655 17.2482,16.5655 C15.1732,16.5655 13.4912,14.8835 13.4912,12.8085 C13.4912,10.7335 15.1732,9.0515 17.2482,9.0515 C19.3232,9.0515 21.0052,10.7335 21.0052,12.8085 Z",
    id: "Stroke-11",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.25,4.7821 C24.25,5.9141 23.332,6.8311 22.201,6.8311 C21.069,6.8311 20.151,5.9141 20.151,4.7821 C20.151,3.6501 21.069,2.7331 22.201,2.7331 C23.332,2.7331 24.25,3.6501 24.25,4.7821 Z",
    id: "Stroke-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.345,4.7821 C14.345,5.9141 13.427,6.8311 12.296,6.8311 C11.164,6.8311 10.246,5.9141 10.246,4.7821 C10.246,3.6501 11.164,2.7331 12.296,2.7331 C13.427,2.7331 14.345,3.6501 14.345,4.7821 Z",
    id: "Stroke-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.787,35.351 C25.787,36.952 24.489,38.25 22.888,38.25 C21.287,38.25 19.989,36.952 19.989,35.351 C19.989,33.75 21.287,32.452 22.888,32.452 C24.489,32.452 25.787,33.75 25.787,35.351 Z",
    id: "Stroke-17",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1659,35.351 C14.1659,36.952 12.8679,38.25 11.2669,38.25 C9.6659,38.25 8.3679,36.952 8.3679,35.351 C8.3679,33.75 9.6659,32.452 11.2669,32.452 C12.8679,32.452 14.1659,33.75 14.1659,35.351 Z",
    id: "Stroke-19",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3354,40.645 L9.8194,40.645 C6.8954,40.645 4.5254,38.275 4.5254,35.351 C4.5254,32.427 6.8954,30.057 9.8194,30.057 L24.3354,30.057 C27.2594,30.057 29.6294,32.427 29.6294,35.351 C29.6294,38.275 27.2594,40.645 24.3354,40.645 Z",
    id: "Stroke-21",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0369,35.4265 C22.9949,35.5115 22.8929,35.5455 22.8079,35.5045 C22.7239,35.4625 22.6889,35.3595 22.7309,35.2755 C22.7719,35.1905 22.8749,35.1565 22.9589,35.1975 C23.0439,35.2395 23.0789,35.3415 23.0369,35.4265 Z",
    id: "Stroke-23",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4241,35.4265 C11.3821,35.5115 11.2801,35.5455 11.1951,35.5045 C11.1111,35.4625 11.0761,35.3595 11.1181,35.2755 C11.1591,35.1905 11.2621,35.1565 11.3461,35.1975 C11.4311,35.2395 11.4661,35.3415 11.4241,35.4265 Z",
    id: "Stroke-25",
    strokeWidth: 2
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcs2);
export default __webpack_public_path__ + "static/media/CCS2.5a71c990a663d46c5423544efa9f5a2a.svg";
export { ForwardRef as ReactComponent };